import GlobalStore from "./store.global";

const isServer = typeof window === "undefined";
let globalStoreInstance: GlobalStore | null = null;

export default function createGlobalStore(): GlobalStore {
  // Server: never cache — each SSR request constructs a fresh RootStore, and
  // reusing a GlobalStore instance across requests would cause mobx-keystone's
  // "object cannot be assigned a new parent when it already has one" error
  // when the second request tries to attach the shared singleton.
  if (isServer) return new GlobalStore({ lastSync: new Date(0) });

  return (globalStoreInstance ??= new GlobalStore({ lastSync: new Date(0) }));
}
